export default class Show {
  constructor(el) {
    this.el = el;

    const triggers = el.querySelectorAll('[data-show-trigger]');

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.handleClicks);
    });
  }

  handleClicks(event) {
    const trigger = event.target;
    const contentContainer = trigger.previousElementSibling;
    const content = contentContainer.querySelector('[data-show-content]');
    const text = trigger.querySelector('[data-text]');
    const styles = window.getComputedStyle(content);
    const marginTop = parseFloat(styles['marginTop']);

    event.preventDefault();

    if (!contentContainer.style.height) {
      text.textContent = trigger.dataset.hide;
      contentContainer.style.height = `${content.offsetHeight + marginTop}px`;
    } else {
      text.textContent = trigger.dataset.show;
      contentContainer.style = null;
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/Show.js